import * as React from "react";

import "./UserList.css";
import User from "../../Models/User/User";
import UserView from "../UserView/UserView";

interface IProps {
    users: User[];
}

interface IState {}

export default class UserList extends React.Component<IProps, IState> {
    render() {
        return (
            <ul className="userList">
                {this.props.users.map((user: User, index: number) => {
                    if (user.status === "online") {
                        return <UserView key={index} user={user} />;
                    }
                })}
            </ul>
        );
    }
}
